import {Component, OnInit, inject} from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import {MsalService} from '@azure/msal-angular';
import {TranslationService} from '@shared/services/translation/translation.service';

@Component({
  selector: 'tdf-root',
  template: `
    @if (isInitialized) {
      <router-outlet></router-outlet>
    }
  `,
  imports: [RouterOutlet],
  standalone: true,
})
export class App implements OnInit {
  private readonly msalService = inject(MsalService);
  private readonly translationService = inject(TranslationService);
  private readonly router = inject(Router);

  isInitialized = false;

  ngOnInit(): void {
    this.msalService.instance.initialize().then(() => {
      this.msalService.instance.handleRedirectPromise().then((response) => {
        if (response) {
          this.router.navigate(['/']);
        } else if (!this.msalService.instance.getAllAccounts().length) {
          this.router.navigate(['/login']);
        }

        this.translationService.init();
        this.isInitialized = true;
      });
    });
  }
}
